export function sanitizeFileName(fileName: string) {
  return fileName.replace(/[`~!@#$%^°&*()|+=?;:'",<>{}[\]\\/\s]/g, '') || 'file'
}

export function splitFileNameAndExtension(fileName: string) {
  const sanitizedFileName = sanitizeFileName(fileName)
  const extensionStart = sanitizedFileName.lastIndexOf('.')

  if (extensionStart <= 0 || extensionStart === sanitizedFileName.length - 1) {
    return { name: sanitizedFileName, extension: undefined }
  }

  return {
    name: sanitizedFileName.slice(0, extensionStart),
    extension: sanitizedFileName.slice(extensionStart + 1),
  }
}

export function formatFileName(name: string, extension?: string) {
  const sanitizedName = sanitizeFileName(name)
  const sanitizedExtension = extension
    ? sanitizeFileName(extension).replace(/^\.+/, '')
    : undefined

  if (!sanitizedExtension) return sanitizedName

  if (
    sanitizedName.toLowerCase().endsWith(`.${sanitizedExtension.toLowerCase()}`)
  ) {
    return sanitizedName
  }

  return `${sanitizedName}.${sanitizedExtension}`
}

export function prepareUploaFormItemId(
  id: unknown
): (string | number)[] | undefined {
  if (id === undefined || id === null) {
    return undefined
  }

  if (typeof id === 'string') {
    return [id]
  }
  if (Number.isInteger(id)) {
    return [id]
  }

  if (
    Array.isArray(id) &&
    id.every(i => Number.isInteger(i) || typeof i === 'string')
  ) {
    return id
  }

  return undefined
}
